// extracted by css-extract-rspack-plugin
export default {"cls1":"CloseButton-cls1_Kpj","cls2":"CloseButton-cls2_nqZ CloseButton-cls1_Kpj"};